module.exports = __webpack_public_path__ + "static/img/casual-cellphones-chatting.2172f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/casual-cellphones-chatting.jpg
// module id = SFEB
// module chunks = 0